import Axios from "axios";
import { toast } from "react-toastify";

const request = Axios.create({
    baseURL: 'https://rtymai-node-backend.onrender.com/'
    // baseURL: "http://localhost:9000/",
});

request.interceptors.request.use(
    (config) => {
        const shouldnotSkip =
            config.url?.startsWith("/api/user/auth/protected/") ||
            config.url?.startsWith("/api/mentor/auth/protected/") ||
            config.url?.startsWith("/api/bookings/") ||
            config.url?.startsWith("/api/slots/") ||
            config.url?.startsWith("/api/mentors/") ||
            config.url?.startsWith("/api/payments/") ||
            config.url?.startsWith("/api/pricing/");

        if (shouldnotSkip) {
            const token = localStorage.getItem("token");
            if (token) {
                config.headers["Authorization"] = `Bearer ${token}`;
            }
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Add response interceptor to handle 406 status
request.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 406) {
            localStorage.removeItem("token");
            window.location.href = "/";
            toast("Session expired. Please log in again.");
            return Promise.reject({
                ...error,
                isNotAcceptable: true,
                userMessage:
                    "The server cannot produce content in the format requested by your browser.",
            });
        }
        return Promise.reject(error);
    }
);

export default request;
